import Vue from "vue"

Vue.mixin({
    methods: {
        planAllow(option, user, premiumHasAllPrivileges = true) {
            if (!user) user = this.user;

            if (premiumHasAllPrivileges && this.hasAPremiumPlan(user)) return true;

            let finded = user.plan_options?.options.find(o => o.slug == option);

            if (finded) {
                return true;
            }

            return false;
        },

        shouldHideOptions(user) {
            const HIDE_OPTIONS_VALUE = 1
            if (!user) user = this.user;

            return user.plan_options?.hide_options === HIDE_OPTIONS_VALUE
                || user.plan_options?.hide_options === HIDE_OPTIONS_VALUE.toString();
        },

        planAllowAny(options) {
            options.forEach(function (option) {
                if (this.planAllow(option)) return true
            })

            return false;
        },

        planAllowAll(options) {
            options.forEach(function (option) {
                if (!this.planAllow(option)) return false
            })

            return true;
        },

        hasAPremiumPlan(user) {
            return user.plan_options?.slug === 'premium'
        },

        planName(user) {
            if (!user) user = this.user;

            return user.plan_options?.name
        }
    }
});
